/// <amd-module name="Feed/Legacy/Protocols/UPack/UPackConnectToFeedPanel" />
import * as React from "react";

import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { IConnectToFeedProps } from "Feed/Legacy/Protocols/Common/IConnectToFeedProps";
import { CopyableTextField, ICopyableTextFieldTelemetry } from "Feed/Legacy/Protocols/Components/CopyableTextField";
import { UPackGetPublishCommand, UPackCiConstants } from "Feed/Legacy/Protocols/UPack/UPackConstants";
import { HubAction } from "Feed/Legacy/Types/IHubState";

import { CiConstants, FwLinks } from "Feed/Common/Constants/Constants";
import * as PackageResources from "Feed/Common/Resources";

export interface IUPackConnectToFeedPanelProps extends IConnectToFeedProps {
    getPublishCommand: UPackGetPublishCommand;
}

export class UPackConnectToFeedPanel extends React.PureComponent<IUPackConnectToFeedPanelProps> {
    public readonly SAMPLE_VERSION = "12.2.0";

    constructor(props: IUPackConnectToFeedPanelProps) {
        super(props);

        CustomerIntelligenceHelper.publishEvent(this.props.pageContext, CiConstants.ConnectToFeed, {
            Action: CiConstants.ConnectToFeedTabChanged,
            Protocol: UPackCiConstants.ProtocolName,
            Context: HubAction[this.props.hubAction]
        });
    }

    public render(): JSX.Element {
        const textfieldId = "upack-connect-to-feed-textfield-label1";
        const command = this.getPublishCommand();
        const displayText = this.getPublishCommand(" \\\n  ");

        return (
            <div className="upack-connect-to-feed-panel connect-to-feed-panel">
                <div className="connect-to-feed-section">
                    <div className="connect-to-feed-section-title" role="heading" aria-level={2}>
                        {PackageResources.UPackConnectControl_ClientTitle}
                    </div>
                    <div className="connect-to-feed-sub-heading">{PackageResources.UPackConnectControl_GetTheCLI}</div>
                    <ExternalLink pageContext={this.props.pageContext} href={FwLinks.DownloadVstsCliTool}>
                        {PackageResources.UPackConnectControl_DownloadCLI}
                    </ExternalLink>
                </div>

                <div className="connect-to-feed-section">
                    <div className="connect-to-feed-section-title" role="heading" aria-level={2}>
                        {PackageResources.UPackConnectControl_PublishPackagesTitle}
                    </div>
                    <div id={textfieldId} className="connect-to-feed-sub-heading">
                        {PackageResources.UPackConnectControl_PushPackageTitle}
                    </div>
                    <CopyableTextField
                        pageContext={this.props.pageContext}
                        cssClassToOverWrite={"pre-wrap-upack"}
                        displayText={displayText}
                        text={command}
                        buttonAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Publish_Copy}
                        textFieldAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_UPack_Command}
                        telemetryProperties={
                            {
                                commandName: CiConstants.CopyCommandPush,
                                feedName: this.props.feed.name,
                                packageName: PackageResources.SamplePackageName_Upack,
                                packageVersion: this.SAMPLE_VERSION,
                                protocol: "Upack"
                            } as ICopyableTextFieldTelemetry
                        }
                        ariaDescribedByIdForLabelText={textfieldId}
                    />
                </div>

                <div className="connect-to-feed-section">
                    <div className="connect-to-feed-section-title" role="heading" aria-level={2}>
                        {PackageResources.UPackConnectControl_DownloadPackagesTitle}
                    </div>
                    <div className="connect-to-feed-sub-heading">
                        {PackageResources.UPackConnectControl_DownloadPackagesInstructions}
                    </div>
                </div>
            </div>
        );
    }

    private getPublishCommand(separator: string = " "): string {
        return this.props.getPublishCommand(
            this.props.feed,
            PackageResources.SamplePackageName_Upack,
            this.SAMPLE_VERSION,
            PackageResources.SamplePackageDescription_Upack,
            separator
        );
    }
}
